export default "__VITE_ASSET__KAG1hYtG__"